import { render, staticRenderFns } from "./hjVideo.vue?vue&type=template&id=04d88b00"
import script from "./hjVideo.vue?vue&type=script&lang=js"
export * from "./hjVideo.vue?vue&type=script&lang=js"
import style0 from "./hjVideo.vue?vue&type=style&index=0&id=04d88b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports